var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlash({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5524 7.99677H5.3549V12.1968C5.3549 13.1768 5.88573 13.3751 6.53323 12.6401L10.9491 7.62344C11.4916 7.01094 11.2641 6.50344 10.4416 6.50344H8.63906V2.30344C8.63906 1.32344 8.10823 1.1251 7.46073 1.8601L3.0449 6.87677C2.50823 7.4951 2.73573 7.99677 3.5524 7.99677Z",
    stroke: "white",
    strokeOpacity: 0.64,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlash);
export default __webpack_public_path__ + "static/media/flash.d833cfc055ea536118da1f1d2f1cbb12.svg";
export { ForwardRef as ReactComponent };